import { useState } from "react";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { setUser } from "state";
import api from "utils/api";
import {
  COOKIE_CONSENT,
  getCookieConsentDecision,
  setAnalyticsCookieConsent,
} from "utils/cookieConsent";

export default function CookieSettings() {
  const user = useSelector((state) => state.user);
  const dispatch = useDispatch();
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState("");
  const decision = getCookieConsentDecision(user);

  const changeConsent = async (nextDecision) => {
    if (saving) return;
    setSaving(true);
    setError("");
    try {
      const { data } = await api.patch("/auth/cookie-consent", {
        decision: nextDecision,
      });
      dispatch(setUser({ user: data.user }));
      setAnalyticsCookieConsent(nextDecision);
    } catch (err) {
      setError(
        err?.response?.data?.message ||
          "Die Einstellung konnte nicht gespeichert werden. Bitte versuche es erneut."
      );
    } finally {
      setSaving(false);
    }
  };

  return (
    <section className="konto-cookie-settings" aria-labelledby="konto-cookies-title">
      <div>
        <h2 id="konto-cookies-title">Cookie-Einstellungen</h2>
        <p>
          Schalte Google Analytics für dein Konto vollständig ein oder aus. Die
          Auswahl bleibt gespeichert; der Cookie-Banner erscheint danach nicht
          erneut. Notwendiger Speicher für Buchung und Login bleibt aktiv.
        </p>
        <Link to="/datenschutz#cookies">Mehr zum Datenschutz</Link>
      </div>
      <div className="konto-cookie-settings__controls" role="group" aria-label="Analyse-Cookies">
        <button
          type="button"
          className={decision === COOKIE_CONSENT.accepted ? "is-active" : ""}
          aria-pressed={decision === COOKIE_CONSENT.accepted}
          disabled={saving}
          onClick={() => changeConsent(COOKIE_CONSENT.accepted)}
        >
          Ein
        </button>
        <button
          type="button"
          className={decision === COOKIE_CONSENT.declined ? "is-active" : ""}
          aria-pressed={decision === COOKIE_CONSENT.declined}
          disabled={saving}
          onClick={() => changeConsent(COOKIE_CONSENT.declined)}
        >
          Aus
        </button>
        <span className="konto-cookie-settings__status" aria-live="polite">
          {saving ? "Wird gespeichert…" : decision === COOKIE_CONSENT.accepted ? "Analyse erlaubt" : decision === COOKIE_CONSENT.declined ? "Analyse ausgeschaltet" : "Noch keine Auswahl"}
        </span>
      </div>
      {error && <p className="auth-alert is-error" role="alert">{error}</p>}
    </section>
  );
}
